<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import SettingTable from './setting-table.vue'

export default {
  page: {
    title: 'Nastavení',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, SettingTable },
}
</script>

<template>
  <Layout>
    <div slot="heading">
      <h1>Nastavení</h1>
    </div>

    <div class="page-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card md-card card-table">
              <div class="card-body"> 
                <SettingTable />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
